document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.sk-search[open], .sk-mobile-navigation[open]').forEach(details => {
    details.removeAttribute('open');
    details.querySelector('summary')?.focus();
  });
});
document.addEventListener('click', event => {
  document.querySelectorAll('.sk-search[open], .sk-mobile-navigation[open]').forEach(details => {
    if (!details.contains(event.target)) details.removeAttribute('open');
  });
  const mobileLink = event.target.closest('.sk-mobile-navigation a');
  if (mobileLink) mobileLink.closest('details').removeAttribute('open');
});
